/**
 * Serviços para assinatura de termo via access_token seguro
 *
 * RN01 - Access token seguro:
 * RN03 - Experiência única de assinatura:
 * Endpoints públicos que permitem acesso ao termo via access_token
 */
export default {
    // Buscar termo por access_token (endpoint público - RN01)
    showByToken:    { method: 'get',  url: 'term_signatures/access/{token}' },
    // Assinar termo por access_token (endpoint público - RN01)
    signByToken:    { method: 'post', url: 'term_signatures/access/{token}/sign' },

    // 2º assinante (cosigner) — endpoints públicos (RN03/RN04)
    showCosignerByToken: { method: 'get',  url: 'term_signatures/cosigner/access/{token}' },
    signCosignerByToken: { method: 'post', url: 'term_signatures/cosigner/access/{token}/sign' },
}
